import { render } from "./salesTable.vue?vue&type=template&id=877fb2f8&scoped=true"
import script from "./salesTable.vue?vue&type=script&lang=js"
export * from "./salesTable.vue?vue&type=script&lang=js"

import "./salesTable.vue?vue&type=style&index=0&id=877fb2f8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877fb2f8"]])

export default __exports__